import './OrderButton.css';

interface OrderButtonProps {
  hidden?: boolean;
  lowered?: boolean;
  leftAligned?: boolean;
}

export default function OrderButton({ hidden = false, lowered = false, leftAligned = false }: OrderButtonProps) {
  return (
    <a
      href="https://tegusbagelco.zobaze.shop/catalog"
      className={`order-btn ${hidden ? 'order-btn-hidden' : ''} ${lowered ? 'order-btn-lowered' : ''} ${leftAligned ? 'order-btn-left' : ''}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      Ordene ahora
    </a>
  );
}
